/* Änderung Start cart_upsell */

var KAJU_FREE_SHIPPING_CENTS = 5000;
var KAJU_SHIPPING_FEE_CENTS  = 499;   // DE Versandkosten
var KAJU_FREE_POST_GRAMS     = 600;   // Kostenloser Tarif per Deutsche Post, gemessen 02.11.2026

document.addEventListener('DOMContentLoaded', function () {

  // ── Fortschrittsbalken + Quick-Total: dynamisch bei Warenkorbänderungen ──
  // Dawn ersetzt .js-contents innerHTML komplett → .totals__total-value wird
  // neu erstellt; Observer auf .js-contents (stabiles Element) statt darauf.
  var cartJsContents = document.querySelector('#main-cart-footer .js-contents');
  if (cartJsContents) {
    new MutationObserver(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateShippingBar(cart.total_price);
          updateQuickCheckoutTotal(cart.total_price, cart.total_weight);
          // Kachel-Badges bei Tabellenänderungen (Menge/Löschen) sync halten
          updateAllSteinBadges(cart);
          // Warenkorb-Icon im Header aktualisieren
          updateCartIconState(cart.item_count);
        });
    }).observe(cartJsContents, { childList: true });
  }

  // ── Sortierung nach Dawn-AJAX-Updates (Mengenänderung etc.) ──
  // Dawn ersetzt #main-cart-items .js-contents – inline <script> läuft
  // nach innerHTML-Zuweisung nicht neu → Observer nötig.
  var cartItemsContents = document.querySelector('#main-cart-items .js-contents');
  if (cartItemsContents) {
    new MutationObserver(function () {
      sortCartItems();
    }).observe(cartItemsContents, { childList: true, subtree: false });
  }

  // ── Kreisportal Upsell: Dazulegen ────────────────────────────
  var upsellBtn = document.querySelector('[data-upsell-add]');
  if (upsellBtn) {
    upsellBtn.addEventListener('click', function () {
      addToCartAndReload(this, this.dataset.variantId, 'Wird hinzugefügt…', 'Dazulegen');
    });
  }

  // ── Zweites Entdecker-Set: Dazulegen (non-tile buttons) ──────
  document.querySelectorAll('[data-add-variant]:not(.cart__stein-tile)').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var orig = this.textContent.trim();
      addToCartAndReload(this, this.dataset.addVariant, '…', orig);
    });
  });

  // ── Entdecker: Upgrade auf Grundset ───────────────────────
  var upgradeBtn = document.querySelector('[data-upgrade-starter]');
  if (upgradeBtn) {
    upgradeBtn.addEventListener('click', function () {
      var btn = this;
      var starterVariantId = btn.dataset.upgradeStarter;
      var removeIds = (btn.dataset.removeVariants || '')
        .split(',').filter(function (id) { return id.trim() !== ''; });

      btn.disabled = true;
      btn.textContent = 'Wird vorbereitet…';

      var updates = {};
      removeIds.forEach(function (id) { updates[id.trim()] = 0; });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Update failed');
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: starterVariantId, quantity: 1 })
          });
        })
        .then(function (res) {
          if (res.ok) { window.location.reload(); }
          else { return res.json().then(function (d) { throw new Error(d.description); }); }
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Upgraden';
          console.error('Upgrade error:', err);
        });
    });
  }

  // ── Entdecker: "Entdecker-Set behalten" ──────────────────────
  var keepBtn = document.querySelector('[data-keep-entdecker]');
  if (keepBtn) {
    keepBtn.addEventListener('click', function () {
      var card = this.closest('.cart__ent-upgrade');
      if (card) card.style.display = 'none';
    });
  }

  // ── Einzelsteine: 3D-Kacheln (Event delegation auf document) ─
  document.addEventListener('click', function (e) {
    var tile = e.target.closest('.cart__stein-tile');
    if (tile) { addSteinTile(tile); }
  });

  // ── Trash-Icon: click → cart-remove-button auslösen ─────────
  document.addEventListener('click', function (e) {
    var icon = e.target.closest('.cart-trash-icon');
    if (!icon) return;
    e.preventDefault();
    var card = icon.closest('.cart-card');
    if (card) {
      var removeLink = card.querySelector('cart-remove-button a');
      if (removeLink) removeLink.click();
    }
  });

});

// ── Einzelstein-Kachel: Press + Bounce/Salto + Cart-Update ohne Reload ─
function addSteinTile(tile) {
  if (tile.dataset.adding) return;
  var variantId = tile.dataset.addVariant;
  if (!variantId) return;

  tile.dataset.adding = '1';
  tile.classList.add('is-pressing');

  var pressStart = Date.now();
  var MIN_PRESS_MS = 140;

  // 30% Chance: Bild macht Salto-Spin
  var isSalto = Math.random() < 0.30;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) {
      // Mindest-Drückdauer einhalten damit Animation sichtbar ist
      var wait = Math.max(0, MIN_PRESS_MS - (Date.now() - pressStart));
      return new Promise(function (resolve) {
        setTimeout(function () { resolve(res); }, wait);
      });
    })
    .then(function () {
      tile.classList.remove('is-pressing');
      tile.classList.add('is-bouncing');
      setTimeout(function () { tile.classList.remove('is-bouncing'); }, 600);
      // Bild-Animation: zufällige Neigung oder Salto
      animateSteinImg(tile, isSalto);
      // Cart-Daten holen und UI aktualisieren
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      updateShippingBar(cart.total_price);
      updateQuickCheckoutTotal(cart.total_price, cart.total_weight);
      // Alle Kachel-Badges aktualisieren
      updateAllSteinBadges(cart);
      // Warenkorb-Icon im Header aktualisieren
      updateCartIconState(cart.item_count);
      // Dawn-Warenkorb-Zähler im Header aktualisieren
      document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
        var countEl = el.querySelector('[aria-hidden="true"]') || el.querySelector('span');
        if (countEl) countEl.textContent = cart.item_count;
      });
      // War der Warenkorb vorher leer, versteckt component-cart.css die Tabelle
      // weiterhin über cart-items.is-empty – Klasse muss beim ersten Add mit runter.
      if (cart.item_count > 0) {
        var cartItemsEl = document.querySelector('cart-items');
        if (cartItemsEl) cartItemsEl.classList.remove('is-empty');
      }
      // Warenkorbtabelle (tbody) neu laden
      refreshCartSection();
    })
    .catch(function (err) {
      tile.classList.remove('is-pressing', 'is-bouncing');
      console.error('Cart error:', err);
    })
    .finally(function () {
      delete tile.dataset.adding;
    });
}

// ── Steinbild-Animation: zufällige Neigung oder Salto ────────
function animateSteinImg(tile, isSalto) {
  var img = tile.querySelector('.cart__stein-tile-img img');
  if (!img || !img.animate) return;

  var delay = 80;
  var ease  = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
  var frames;

  if (isSalto) {
    // 360°-Drehung in der Bildschirmebene beim Hüpfen
    frames = [
      { transform: 'translateY(0)     rotate(0deg)   scale(1)',    offset: 0    },
      { transform: 'translateY(-26px) rotate(130deg) scale(1.15)', offset: 0.28 },
      { transform: 'translateY(-28px) rotate(255deg) scale(1.18)', offset: 0.55 },
      { transform: 'translateY(-8px)  rotate(340deg) scale(1.06)', offset: 0.82 },
      { transform: 'translateY(0)     rotate(360deg) scale(1)',    offset: 1    }
    ];
    img.animate(frames, { duration: 750, delay: delay, easing: ease });
  } else {
    // Zufällige Neigung 3–20°, zufällige Richtung, landet wieder gerade
    var sign = Math.random() < 0.5 ? 1 : -1;
    var deg  = sign * (3 + Math.floor(Math.random() * 18));
    frames = [
      { transform: 'translateY(0)     rotate(0deg)                scale(1)',    offset: 0    },
      { transform: 'translateY(-20px) rotate(' + deg + 'deg)      scale(1.1)',  offset: 0.38 },
      { transform: 'translateY(-5px)  rotate(' + (deg * 0.4) + 'deg) scale(1.02)', offset: 0.62 },
      { transform: 'translateY(-10px) rotate(' + (deg * 0.15) + 'deg) scale(1.05)', offset: 0.78 },
      { transform: 'translateY(0)     rotate(0deg)                scale(1)',    offset: 1    }
    ];
    img.animate(frames, { duration: 620, delay: delay, easing: ease });
  }
}

// ── Steinzähler-Badge einer Kachel aktualisieren ─────────────
function updateSteinBadge(tile, cart) {
  var variantId = tile.dataset.addVariant;
  if (!variantId) return;

  // Anzahl dieser Variante im Warenkorb ermitteln
  var count = 0;
  for (var i = 0; i < cart.items.length; i++) {
    if (String(cart.items[i].variant_id) === String(variantId)) {
      count += cart.items[i].quantity;
    }
  }

  var face = tile.querySelector('.cart__stein-tile-face');
  if (!face) return;

  var badge = face.querySelector('.cart__stein-tile-count');
  if (count > 0) {
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'cart__stein-tile-count';
      badge.setAttribute('aria-label', count + ' im Warenkorb');
      face.insertBefore(badge, face.firstChild);
    }
    badge.textContent = count;
    badge.setAttribute('aria-label', count + ' im Warenkorb');
  } else {
    if (badge) badge.remove();
  }
}

// ── Versand-Ziel-Panel als Progressbar aktualisieren ─────────
function updateShippingBar(totalCents) {
  var goalEl = document.querySelector('.cart__shipping-goal');
  if (!goalEl) return;

  var pct       = Math.min(100, Math.floor(totalCents * 100 / KAJU_FREE_SHIPPING_CENTS));
  var remaining = KAJU_FREE_SHIPPING_CENTS - totalCents;

  // Grüne Füllung: CSS Custom Property direkt auf dem Panel setzen
  goalEl.style.setProperty('--kaju-progress', pct + '%');

  var badgeEl = goalEl.querySelector('.cart__shipping-goal-badge');
  if (remaining <= 0) {
    goalEl.classList.add('cart__shipping-goal--reached');
    if (badgeEl) badgeEl.textContent = '✓ Aktiv';
  } else {
    goalEl.classList.remove('cart__shipping-goal--reached');
    var eur = Math.floor(remaining / 100);
    var ct  = String(remaining % 100).padStart(2, '0');
    if (badgeEl) badgeEl.textContent = 'Noch ' + eur + ',' + ct + '\u00a0\u20ac';
  }
}

// ── Quick-Checkout: Warenwert + Versandzeile aktualisieren ───
function updateQuickCheckoutTotal(totalCents, totalGrams) {
  // Warenwert-Zeile
  var totalEl = document.querySelector('.cart__quick-checkout-total');
  if (totalEl) {
    var euros = Math.floor(totalCents / 100);
    var cents = String(totalCents % 100).padStart(2, '0');
    totalEl.textContent = euros + ',' + cents + '\u00a0\u20ac';
  }
  // Versand-Zeile
  var shippingEl = document.querySelector('.cart__quick-checkout-shipping');
  if (shippingEl) {
    if (totalCents >= KAJU_FREE_SHIPPING_CENTS || totalGrams <= KAJU_FREE_POST_GRAMS) {
      shippingEl.textContent = 'Kostenlos';
      shippingEl.classList.add('cart__quick-checkout-shipping--free');
    } else {
      shippingEl.textContent = '4,99\u00a0\u20ac';
      shippingEl.classList.remove('cart__quick-checkout-shipping--free');
    }
  }
}

// ── Helper: Add-to-Cart + Reload ─────────────────────────────
function addToCartAndReload(btn, variantId, loadingText, errorText) {
  if (!variantId) return;
  btn.disabled = true;
  btn.textContent = loadingText;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(function (res) {
      if (res.ok) { window.location.reload(); }
      else { return res.json().then(function (d) { throw new Error(d.description); }); }
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.textContent = errorText;
      console.error('Cart error:', err);
    });
}

// ── Alle Kachel-Badges auf einmal aktualisieren ───────────
function updateAllSteinBadges(cart) {
  document.querySelectorAll('.cart__stein-tile').forEach(function (tile) {
    updateSteinBadge(tile, cart);
  });
}

// ── Warenkorbtabelle via Sections-API neu laden ───────────
// Wird nach Kachel-Adds aufgerufen damit Tabellenzeilen
// (neue Artikel, Mengen) ohne Seitenreload erscheinen.
function refreshCartSection() {
  fetch('/cart?sections=main-cart-items')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var html = data['main-cart-items'];
      if (!html) return;
      var parser = new DOMParser();
      var newDoc = parser.parseFromString(html, 'text/html');
      // Cart-Cards im Body ersetzen (neue div-Struktur)
      var newBody = newDoc.querySelector('.cart-items__body');
      var curBody = document.querySelector('.cart-items__body');
      if (newBody && curBody) {
        curBody.innerHTML = newBody.innerHTML;
        sortCartItems();
      }
    })
    .catch(function (err) { console.error('Section refresh error:', err); });
}

// ── Einzelsteine im Warenkorb nach Farbreihenfolge sortieren ──
function sortCartItems() {
  var body = document.querySelector('.cart-items__body');
  if (!body) return;
  var cards = Array.from(body.querySelectorAll('.cart-card'));
  cards.sort(function (a, b) {
    return (parseInt(a.dataset.sortOrder) || 0) - (parseInt(b.dataset.sortOrder) || 0);
  });
  cards.forEach(function (card) { body.appendChild(card); });
}

// ── Warenkorb-Icon im Header: leer/voll per Klasse steuern ──
function updateCartIconState(itemCount) {
  var btn = document.getElementById('cart-icon-bubble');
  if (!btn) return;
  if (itemCount > 0) {
    btn.classList.add('kaju-cart--has-items');
  } else {
    btn.classList.remove('kaju-cart--has-items');
  }
}

/* Änderung Ende cart_upsell */


